import { NgModule } from '@angular/core';
// import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
// import { CompanyLogoComponent } from './company-logo/company-logo.component';

@NgModule({
  declarations: [
    // CompanyInfoComponent
    // CompanyLogoComponent
  ],
  imports: [
	  CommonModule,
    // BrowserModule,
    FormsModule,
    HttpClientModule,
    // BrowserAnimationsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule
  ],
  providers: [],
})
export class CompanyModule { }